export default __webpack_public_path__ + "static/logo-e35857f8bcd5a1beb1bc0e8b886efff2.png";